// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chat-rating{max-width:100%;min-height:100%;margin:0 auto}.chat-rating .v-rating{margin-top:7px}@media screen and (max-width:599px){.chat-rating .v-rating{margin-top:17px}}", ""]);
// Exports
module.exports = exports;
